import axios from 'axios'

import { CalculationServicePrintPaperPackagingPublishingApi } from '../../../publish/calculation/apis/calculation-service-print-paper-packaging-publishing-api'
import { Configuration } from '../../../publish/calculation/configuration'
import { setupAxiosInterceptors } from '../../axios-interceptor-utils'

export class CalculationServicePrintPaperPackagingPublishing extends CalculationServicePrintPaperPackagingPublishingApi {
  constructor(
    protected basePath: string,
    private getTokenFn?: () => Promise<string>,
  ) {
    super(new Configuration({ basePath: basePath }), basePath, axios.create())
    setupAxiosInterceptors(this.axios, this.getTokenFn)
  }
}
